module.exports = __webpack_public_path__ + "img/items-grid-02.b667f8c1.png";